import { ErrorHandler, Injectable, inject, NgZone } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { ToastService } from './toast.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private toastService = inject(ToastService);
  private transloco = inject(TranslocoService);
  private zone = inject(NgZone);

  handleError(error: any): void {
    // 1. Capture the error with Sentry
    Sentry.captureException(error);

    // 2. Preserve the existing toast‑notification logic
    console.error('Global error caught:', error);
    this.zone.run(() => {
      const msg = this.toastService.mapBackendError(error);
      this.toastService.show(msg, 'error');
    });
  }
}
